import { Clock, LogOut } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import Button from './Button';

interface InactivityWarningModalProps {
  isOpen: boolean;
  secondsRemaining: number;
  onContinue: () => void;
  onLogout: () => void;
}

export default function InactivityWarningModal({
  isOpen,
  secondsRemaining,
  onContinue,
  onLogout,
}: InactivityWarningModalProps) {
  const { t } = useTranslation('common');

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      {/* Overlay */}
      <div className="fixed inset-0 bg-black bg-opacity-50 transition-opacity" />

      {/* Dialog */}
      <div className="flex min-h-full items-center justify-center p-4">
        <div className="relative bg-white rounded-lg shadow-xl max-w-md w-full p-6 transform transition-all">
          {/* Icon */}
          <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-amber-100 mb-4">
            <Clock className="h-6 w-6 text-amber-600" />
          </div>

          {/* Content */}
          <h3 className="text-lg font-semibold text-gray-900 text-center mb-2">
            {t('inactivity.title')}
          </h3>
          <p className="text-gray-600 text-center mb-4">
            {t('inactivity.message')}
          </p>

          {/* Countdown */}
          <div className="flex justify-center mb-6">
            <div className="text-4xl font-bold text-amber-600 bg-amber-50 rounded-lg px-6 py-3">
              {secondsRemaining}s
            </div>
          </div>

          <p className="text-sm text-gray-500 text-center mb-6">
            {t('inactivity.securityNote')}
          </p>

          {/* Actions */}
          <div className="flex flex-col gap-3">
            <Button
              variant="primary"
              onClick={onContinue}
              className="w-full justify-center"
            >
              Continuer ma session
            </Button>
            <Button
              variant="outline"
              onClick={onLogout}
              className="w-full justify-center text-gray-600"
            >
              <LogOut className="w-4 h-4 mr-2" />
              Me déconnecter
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
